module.exports = __webpack_public_path__ + "img/anewitem-cars.aa56393f.svg";